/**
 * フロントでは header.php が `html.js-home-initial-gate` を付与し、
 * base.scss で主要ブロックを一時非表示にする。ここで JS 実行後に解除しないと画面が真っ白のままになる。
 */
import { getThemeColor } from './page-theme.js';

// 初回オープニング中は opening.js がゲート解除する
if (
  document.documentElement.classList.contains('js-home-initial-gate') &&
  !document.documentElement.classList.contains('is-opening')
) {
  document.documentElement.classList.remove('js-home-initial-gate');
}

function updateNavThemeColor() {
  const navContent = document.querySelector('.navContent');
  if (!navContent) {
    return;
  }
  navContent.style.setProperty('--nav-theme-color', getThemeColor(window.location.pathname));
}

updateNavThemeColor();
document.addEventListener('swup:replaced', function () {
  updateNavThemeColor();
  forceCloseNavIfOpen();
});

/**
 * ボタン中心と画面四隅まで届く最小直径を CSS 変数に渡す。
 * 巨大な固定 px / vmax 円の scale を避け、GPU で滑らかに動かす。
 */
function updateNavRevealOrigin() {
  const navBt = document.querySelector('.navBt');
  const navBg = document.querySelector('.navContent-bg');
  if (!navBt || !navBg) {
    return;
  }

  const rect = navBt.getBoundingClientRect();
  const cx = rect.left + rect.width / 2;
  const cy = rect.top + rect.height / 2;
  const w = window.innerWidth;
  const h = window.innerHeight;

  const maxDist = Math.max(
    Math.hypot(cx, cy),
    Math.hypot(w - cx, cy),
    Math.hypot(cx, h - cy),
    Math.hypot(w - cx, h - cy)
  );

  navBg.style.setProperty('--nav-reveal-x', `${cx}px`);
  navBg.style.setProperty('--nav-reveal-y', `${cy}px`);
  navBg.style.setProperty('--nav-reveal-size', `${Math.ceil(maxDist * 2.08)}px`);
}

updateNavRevealOrigin();
window.addEventListener('resize', updateNavRevealOrigin, { passive: true });
window.addEventListener('orientationchange', updateNavRevealOrigin, { passive: true });

function syncNavA11y(navContent, open) {
  navContent.setAttribute('aria-hidden', open ? 'false' : 'true');
}

let navCloseScheduled = false;

export function scheduleNavCloseAfterTransition() {
  const navContent = document.querySelector('.navContent');
  if (!navContent || !navContent.classList.contains('is-open')) {
    return;
  }
  navCloseScheduled = true;
}

export function closeNavIfScheduled() {
  if (!navCloseScheduled) {
    return;
  }
  navCloseScheduled = false;
  setNavOpen(false, { instant: true });
}

function forceCloseNavIfOpen() {
  const navContent = document.querySelector('.navContent');
  if (!navContent || !navContent.classList.contains('is-open')) {
    navCloseScheduled = false;
    return;
  }
  navCloseScheduled = false;
  setNavOpen(false, { instant: true });
}

function setNavOpen(open, options) {
  const instant = options && options.instant === true;
  const navBt = document.querySelector('.navBt');
  const navContent = document.querySelector('.navContent');
  if (!navBt || !navContent) return;

  if (open) {
    document.documentElement.classList.remove('is-nav-instant-close');
    updateNavRevealOrigin();
    navBt.setAttribute('aria-expanded', 'true');
    syncNavA11y(navContent, true);
    document.documentElement.classList.add('is-nav-open');

    // 起点更新 → 次フレームで scale 開始（transition の取りこぼし防止）
    requestAnimationFrame(() => {
      navBt.classList.add('is-open');
      navContent.classList.add('is-open');
    });
    return;
  }

  if (instant) {
    document.documentElement.classList.add('is-nav-instant-close');
    void navContent.offsetWidth;
  } else {
    document.documentElement.classList.remove('is-nav-instant-close');
  }

  navBt.classList.remove('is-open');
  navContent.classList.remove('is-open');
  navBt.setAttribute('aria-expanded', 'false');
  syncNavA11y(navContent, false);
  document.documentElement.classList.remove('is-nav-open');

  if (instant) {
    requestAnimationFrame(() => {
      document.documentElement.classList.remove('is-nav-instant-close');
    });
  }
}

const navContentEl = document.querySelector('.navContent');
if (navContentEl) {
  syncNavA11y(navContentEl, navContentEl.classList.contains('is-open'));
}

/**
 * ハンバーガーメニュー `.navBt` クリックでクラスをトグル（最優先で document に委譲）
 */
document.addEventListener(
  'click',
  (e) => {
    const navBt = e.target.closest('.navBt');
    if (!navBt) return;
    setNavOpen(!navBt.classList.contains('is-open'));
  },
  true
);

/**
 * メニュー内リンク押下でナビを閉じる（.is-open を解除）
 * 下部ボックス（お問い合わせ・プライバシーポリシー等）も含める
 */
document.addEventListener(
  'click',
  (e) => {
    const navLink = e.target.closest(
      '.navContent a:not([target="_blank"]):not([href^="tel:"])'
    );
    if (!navLink) return;
    scheduleNavCloseAfterTransition();
  },
  true
);

/**
 * FAQ `.js-pullDown` … クリックで is-pullOn を付け外し（開閉アニメは CSS）
 */
document.addEventListener('click', function (e) {
  var trigger = e.target.closest('.js-pullDown');
  if (trigger) {
    trigger.classList.toggle('is-pullOn');
  }
});
